import { FormItems, Spec } from "src/app/services/api/masterdata/masterdata.service";

export class SpecObject implements Spec{
    hjid: string;
    value: string;
    type: string;
    formItems: FormItems[];
    description: string;
}